import type { NudgeSource } from '@cobliteam/hooks/src/useNudge/types';
import { useChecklistComplianceNudge } from './useChecklistComplianceNudge';
import { useCobliConectaNudge } from './useCobliConectaNudge';
import { useGeofenceNudge } from './useGeofenceNudge';
import { useGroupNudge } from './useGroupNudge';
import { useScheduleInstallationNudge } from './useScheduleInstallationNudge';

/**
 * Every nudge the floating stack can show, in declaration order.
 *
 * MUST stay module level and MUST NOT be reordered or filtered at runtime — each entry is a hook,
 * so the array's length and order are part of the Rules of Hooks contract (`useNudges` throws in
 * dev if the count changes). Ordering on screen comes from `kind` and `priority`, never from this
 * array's order.
 */
export const NUDGE_SOURCES: NudgeSource[] = [useScheduleInstallationNudge, useCobliConectaNudge, useChecklistComplianceNudge, useGeofenceNudge, useGroupNudge];

/** Total nudges visible at once, across both kinds. */
export const NUDGE_LIMIT = 4;
